<div class="navigation-container" style="margin:12px; vertical-align: bottom;">
  <div style="float: right; font-size: 22px; font-weight: 500; margin-top: 12px; padding-right: 8px;">
    <a [ngClass]="{'activecountry': this.oroservice.cookieservice.get('lang') =='de','inactivecountry': this.oroservice.cookieservice.get('lang') !='de'}"
      (click)="SetDE()"><span>DE</span></a>
      &nbsp;-&nbsp;
      <a [ngClass]="{'activecountry': this.oroservice.cookieservice.get('lang') =='fr','inactivecountry': this.oroservice.cookieservice.get('lang') !='fr'}"
        (click)="SetFR()"><span>FR</span></a>

        <!-- Italienisch wird erstmals nicht unterstützt -->
        <!-- &nbsp;-&nbsp;
        <a [ngClass]="{'activecountry': this.oroservice.cookieservice.get('lang') =='it' ,'inactivecountry': this.oroservice.cookieservice.get('lang') !='it'}"
          (click)="SetIT()"><span>IT</span></a> -->

          &nbsp;-&nbsp;

          @if (this.oroservice.mode) {
            <a (click)="this.Logout()" >
              <mat-icon style="color:#be0000; font-weight: 900; top: 5px; position: relative; cursor: pointer;"
              matTooltip="{{ 'Login.Logout' | translate }}">login</mat-icon>
            </a>
          }
        </div>
        <div class="navigation-left">
          <a class="logo" routerLink="/" routerLinkActive="active">
            <img src="assets/img/mediserv-header.gif" width="auto" height="80px">
          </a>
        </div>
      </div>


      <main>
        <router-outlet style="margin-bottom: 20px;"></router-outlet>
      </main>

      <footer>
        <app-footer-contact class="footer-contact"></app-footer-contact>
        <!-- <app-footer></app-footer> -->
      </footer>